export default {
  methods: {
    __(key, replace) {
      let translation = true

      translation = this.$page.words[key]
        ? this.$page.words[key]
        : key

      _.forEach(replace, (value, key) => {
        translation = translation.replace(':' + key, value)
      })

      return translation
    },
    addToQuery(params, query) {

      if (query === undefined) {
        query = { ...this.query() }
      }

      let urlParams = Object.assign(query, params)

      this.$inertia.visit(
        route(route().current(), urlParams)
      )
    },
    removeFromQuery(params, query) {
      if (query === undefined) {
        query = { ...this.query() }
      }

      params.forEach(param => {
        delete query[param]
      })

      this.$inertia.visit(
        route(route().current(), query)
      )
    },
    query() {
      return this.$query.parse(window.location.search)
    },
    queryStringify(query) {
      return this.$query.stringify(query);
    },
    queryAdd(add) {
      let query = { ...this.query() }
      Object.keys(add).forEach((key) => {
        query[key] = add[key]
      });

      return query;
    },
    queryExcept(exceptions) {
      let query = { ...this.query() }
      exceptions.forEach(exception => {
        delete query[exception]
      })

      return query
    },
    changePage(page, route) {
      let query = { ...this.query() }
      query.page = page;

      if (route === undefined) {
        route = this.route().current()
      }

      this.$inertia.visit(this.route(route), {
        data: query
      })
    },
  }
}